module.exports = __webpack_public_path__ + "img/production-light.25872dfa.svg";